import api from '@/api'
import router from '@/router'
import {INITIALIZE} from '../mutations/available';

export const initApplication = async ({commit}) => {
  try {
    let initialData = await api.getInitialData()
    commit(INITIALIZE, initialData)
  } catch (e) {
    console.log(e)
  }
}
